import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent, ReactNode } from 'react';

import BPImage from '../../../ui/v2/image';
import PureStaticContent from '../../../ui/v2/pure-static-content';
import Trans from 'next-translate/Trans';

export type TBrandHistory = {
  html: string;
  imageURL?: string;
  stock: string;
  brand: string;
  vehicle?: any;
};

const BrandHistory: FunctionComponent<TBrandHistory> = ({
  html,
  imageURL,
  brand,
  stock,
  vehicle,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-blue-10">
      <div className="container max-md:px-4 mx-auto text-justify lg:text-left w-full max-lg:flex-col grid lg:auto-cols-[calc(100%/4)]">
        <div className="w-full text-justify grid lg:col-span-3 justify-start lg:pr-4">
          <div className="max-lg:flex max-lg:flex-row mb-8 max-lg:h-[162px] items-center block ">
            <p className="font-extrabold text-[32px] leading-[43px] text-left max-lg:w-1/2 block max-lg:line-clamp-4">
              {t('common:brand-history.title', {
                vehicle: `${vehicle.brand.name || ''} ${
                  vehicle.model?.name || ''
                } ${vehicle.version?.name || ''}`,
              })}
            </p>
            <div className="lg:hidden flex relative w-fit bg-blue-10 max-lg:w-1/2 h-[162px] ">
              <BPImage
                src={`${process.env.STATIC_PREFIX}/brands/history/${
                  vehicle.brand.alias || vehicle.brand.slug.split('-')[0]
                }.png`}
                layout="fill"
                objectFit="contain"
                objectPosition="right"
                className={cx(
                  'lg:py-12 bg-blend-multiply w-fit bg-blue-10 h-[162px]'
                )}
                alt={brand}
              />
            </div>
          </div>
          <div>
            <PureStaticContent html={html} />
            <div className="text-[18px] leading-[28px] max-lg:text-base">
              <Trans
                i18nKey={'common:brand-history.see-more'}
                components={{ strong: <strong /> }}
                values={{
                  count: stock,
                  vehicle: `${vehicle.brand.name || ''}`,
                }}
              />
            </div>
          </div>
        </div>
        <div className="hidden lg:block relative m-auto grid col-start-4 pl-8 lg:pl-7 bg-blue-10">
          <BPImage
            src={`${process.env.STATIC_PREFIX}/brands/history/${
              vehicle.brand.alias || vehicle.brand.slug.split('-')[0]
            }.png`}
            layout="fixed"
            width={300}
            height={300}
            objectFit="contain"
            objectPosition="right"
            className={cx('w-fit h-fit bg-blend-multiply bg-blue-10')}
            alt={brand}
          />
        </div>
      </div>
    </div>
  );
};

export default BrandHistory;
